import script from "./StudyAssistantModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./StudyAssistantModal.vue?vue&type=script&setup=true&lang=ts"

import "./StudyAssistantModal.vue?vue&type=style&index=0&id=b669574a&lang=scss"

const __exports__ = script;

export default __exports__